module.exports = __webpack_public_path__ + "static/assets/bf02b9d2b21057351848f95346c3daf1.png";